<template>
  <div>
    <el-row>
      <el-col :span="12">
        <div class="label">
          <slot></slot>
        </div>
      </el-col>
      <el-col :span="12" style="height: 41px" class="meal-edit">
        <div class="edit">
          <div v-if="isEdit" style="height:100%">
            <input class="meal-input" ref="input" @keyup="onKeyup($event)" @keydown="onKeydown($event)" v-clickoutside="clickout" type="text" v-model.number="data" />
          </div>
          <div v-else @click="clickText" style="height: 100%;padding-left: 15px; cursor:text">{{data}}
            <span style="color:#fa7a35" v-if="addSub">&nbsp;+{{addSub}}</span>
            <span style="color:#fa7a35" v-if="addView">&nbsp;+{{addView}}</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Clickoutside from 'element-ui/lib/utils/clickoutside';

export default {
  name: 'editMeal',
  directives: { Clickoutside },
  data() {
    return {
      isEdit: false,
      data: '',
      isKeydown: false,
    };
  },
  props: ['value', 'editable','addSub','addView'],
  watch: {
    value: {
      handler() {
        this.data = this.value;
      },
      immediate: true
    },
    isEdit(val) {
      if (val) {
        this.$nextTick(params => {
          if (this.$refs.input) {
            this.$refs.input.focus();
          }
        });
      }
    }
  },
  methods: {
    clickout() {
      if (this.isEdit) {
        this.isEdit = false;
      }
    },
    clickText() {
      if (this.editable) {
        this.isEdit = true;
      }
    },
    onKeyup(e) {
      this.isKeydown = false;
      this.$emit('input', this.data);
    },
    onKeydown(e) {
      // Up key: Increase the value
      // if(this.data.toString().length == 1 && e.keyCode == 8) {
      //   e.preventDefault();
      //   return;
      // }
      if (e.keyCode === 38) {
        e.preventDefault();
        return;
      }
      // Down key: Decrease the value
      if (e.keyCode === 40) {
        e.preventDefault();
        return;
      }
      // Allow dot key for decimals:
      if (e.keyCode === 110 || e.keyCode === 190) {
        e.preventDefault();
        return;
      }
      // Allow these keys only:
      if (
        // backspace, delete, tab, escape, enter, dot
        [46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) >= 0 ||
        // Ctrl/cmd+A
        (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
        // Ctrl/cmd+C
        (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
        // Ctrl/cmd+R
        (e.keyCode === 82 && (e.ctrlKey || e.metaKey)) ||
        // Ctrl/cmd+X
        (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
        // home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)
      ) {
        return;
      }
      if (
        (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  background: #fafafa;
  padding-left: 10px;
  border: 1px solid var(--contact-division-color);
  border-bottom: none;
  color: #555;
}
.edit {
  border: 1px solid var(--contact-division-color);
  border-bottom: none;
  border-left: none;
  height: 100%;
}
.meal-input {
    height: 100%;
    width: 100%;
    display: block;
    border: none;
    -webkit-appearance: none;
    outline: none;
    padding-left: 15px;
}
</style>




// WEBPACK FOOTER //
// src/components/global/editMeal.vue